var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { SAVVY_CONNECTION_ID_CACHE_KEY, useGetSavvyConnectionIdMutation, } from "../services/connect";
import { linkedAutoAccount, linkedHomeAccount, } from "../features/applicant/applicantSlice";
import { AUTH_STATUS } from "../lib/constants";
import AppBody from "../components/AppBody";
import Button from "../components/connect-ui/Button";
import Container from "../components/connect-ui/Container";
import Header from "../components/Header";
import Image from "../components/Image";
import IssuerHeader from "../components/IssuerHeader";
import { PHASE } from "../routeConfig";
import RouteHeaderLogo from "../components/RouteHeaderLogo";
import classNames from "classnames";
import { clearedTempAccessTimeout } from "../features/auth/authSlice";
import { clickedQuoteConsentButton } from "../lib/Avo";
import useAffiliateConfig from "../hooks/useAffiliateConfig";
import useAppDispatch from "../hooks/useAppDispatch";
import useAppSelector from "../hooks/useAppSelector";
import useCurrentProductLine from "../hooks/useCurrentProductLine";
import useEventPublisher from "../hooks/useEventPublisher";
import useHandlePolicyOnly from "../hooks/useHandlePolicyOnly";
import useMemoryHistory from "../hooks/useMemoryHistory";
function LegalDisclaimer(_a) {
    var partnerMessage = _a.partnerMessage;
    var privacyPolicyURL = useAffiliateConfig().privacyPolicyURL;
    return (React.createElement("div", { className: "text-[10px] font-light leading-tight text-gray-100" },
        React.createElement("p", null,
            partnerMessage,
            React.createElement("strong", null, "Comparing insurance with Savvy is free and will not affect your credit score."),
            " ",
            "By clicking \u201CContinue\u201D I instruct Trellis to share its information about me with Savvy, consent and agree to Savvy's",
            " ",
            React.createElement("a", { className: "text-current underline", href: privacyPolicyURL, target: "_blank", rel: "noreferrer" }, "Privacy Policy"),
            ", and",
            " ",
            React.createElement("a", { className: "text-current underline", href: "https://savvy.insure/terms", target: "_blank", rel: "noreferrer" }, "Terms of Service"),
            ", including the arbitration provision and class action waiver, and to the use of third-party consumer reports by Savvy's insurers to calculate accurate quotes for me.")));
}
var linkActions = {
    auto: linkedAutoAccount,
    home: linkedHomeAccount,
};
export default function QuoteConsentRoute() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _a = React.useState(false), submitDisabled = _a[0], setSubmitDisabled = _a[1];
    var _b = React.useState(false), error = _b[0], setError = _b[1];
    var eventPublisher = useEventPublisher();
    var policyOnly = useAppSelector(function (state) { return state.configuration; }).policyOnly;
    var history = useMemoryHistory();
    var _c = useAppSelector(function (state) { return state.auth; }), tempAccessKeyTimeoutID = _c.tempAccessKeyTimeoutID, auto = _c.auto, home = _c.home;
    var currentIssuer = useAppSelector(function (state) { return state.applicant.currentIssuer; });
    var handlePolicyOnly = useHandlePolicyOnly();
    var getSavvyConnectionId = useGetSavvyConnectionIdMutation({
        fixedCacheKey: SAVVY_CONNECTION_ID_CACHE_KEY,
    })[0];
    var dispatch = useAppDispatch();
    var productLine = useCurrentProductLine();
    var didLinkAutoAccount = productLine === "auto";
    var didLinkHomeAccount = productLine === "home";
    var linkAction = didLinkAutoAccount
        ? linkActions.auto
        : didLinkHomeAccount
            ? linkActions.home
            : linkActions.auto;
    var accountInfo = didLinkAutoAccount ? auto.accountInfo : home.accountInfo;
    var authStatus = didLinkAutoAccount ? auto.status : home.status;
    var selectedIssuer = didLinkAutoAccount
        ? currentIssuer.auto
        : currentIssuer.home;
    var partnerMessage = "";
    function handleQuoteConsent(connectionId) {
        var authSuccess = authStatus === AUTH_STATUS.SUCCESS;
        if (tempAccessKeyTimeoutID) {
            clearTimeout(tempAccessKeyTimeoutID);
            dispatch(clearedTempAccessTimeout());
        }
        // For any Savvy user that is skipping our Remarketing opt-in, we need
        // to now set their account to linked instead after quote consent.
        // NOTE: Savvy is not connected to the account until the user provides quote consent.
        // This is important because Partners must not hide the consent screen since we do not
        // trigger onSuccess until after the user quote consent is provided. Refer to
        // documentation captured on SAV-1805 for more context.
        if (authSuccess) {
            dispatch(linkAction());
        }
        if (policyOnly) {
            return handlePolicyOnly({
                accountLinked: authSuccess,
                savvyConnectionId: connectionId,
            });
        }
        history.push(didLinkAutoAccount ? PHASE.POLICIES_LOADING : PHASE.HOME_POLICIES_LOADING);
    }
    function handleClick() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setSubmitDisabled(true);
                eventPublisher.provideConsent();
                clickedQuoteConsentButton(commonAnalyticsProperties);
                if (accountInfo.connectionId && accountInfo.temporaryConnectionToken) {
                    getSavvyConnectionId({
                        connectionId: accountInfo.connectionId,
                        temporaryConnectionToken: accountInfo.temporaryConnectionToken,
                    })
                        .unwrap()
                        .then(handleQuoteConsent);
                }
                else {
                    setError(true);
                }
                return [2 /*return*/];
            });
        });
    }
    if (error) {
        throw new Error("Quote Consent Error: Missing account connection ID or temp connection token");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, null,
            React.createElement(Container, { className: "flex grow flex-col" },
                React.createElement("div", { className: "grow" },
                    React.createElement(IssuerHeader, { issuer: selectedIssuer, style: { paddingLeft: 0, paddingRight: 0 } }),
                    React.createElement("div", { className: "mx-auto flex h-[70px] w-[70px] items-center justify-center" },
                        React.createElement(Image, { src: "/assets/images/consentCheckmark.svg", alt: "", width: 70, height: 52 }))),
                React.createElement("footer", { className: classNames("py-4 md:py-6") },
                    React.createElement("div", { className: "mb-4" },
                        React.createElement(Button, { id: "quote-consent", onClick: handleClick, disabled: submitDisabled }, "Continue")),
                    React.createElement(LegalDisclaimer, { partnerMessage: partnerMessage }))))));
}
